import { useParams, useLocation, useHistory } from 'react-router-dom'

/**
 * Add params and location hook into child components
 * @param {} Component
 * @returns
 */
const withParams = (Component) => {
  return (props) => {
    const params = useParams()
    const location = useLocation()
    const history = useHistory()
    const newProps = { ...props, params, location, history }
    return <Component {...newProps} />
  }
}

export default withParams